<!--
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 14:58:07
 * @LastEditors: knight
 * @LastEditTime: 2022-01-19 17:11:27
-->
<template>
  <div class="tab-bars">
    <router-link
      class="tab-bar-item"
      v-for="ele in tabBars"
      :class="{ active: path === ele.link }"
      :key="ele.link"
      :to="ele.link"
    >
      <img :src="[path === ele.link ? ele.selectIcon : ele.icon]" />
      <span>{{ ele.title }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabBars: [
        {
          key: '/',
          icon: require('@/assets/images/home_noselect.png'),
          selectIcon: require('@/assets/images/home_select.png'),
          title: '首页',
          link: '/',
        },
        {
          key: '/activity',
          icon: require('@/assets/images/activety_noselect.png'),
          selectIcon: require('@/assets/images/activety_select.png'),
          title: '活动广场',
          link: '/activity/index',
        },
        {
          key: '/anchor',
          icon: require('@/assets/images/live_line.png'),
          selectIcon: require('@/assets/images/live_line_select.png'),
          title: '主播广场',
          link: '/anchor/index',
        },
        {
          key: '/mine',
          icon: require('@/assets/images/mine.png'),
          selectIcon: require('@/assets/images/mine_select.png'),
          title: '我的',
          link: '/mine',
        },
      ],
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="less" scoped>
.tab-bars {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 90px;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px -2px 22px rgba(0, 0, 0, 0.06);
  .tab-bar-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &.active {
      color: @color-primary;
    }
    img {
      margin-bottom: 4px;
      width: 36px;
      height: 36px;
    }
    span {
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>
